import { ca } from '@cian/analytics';

export function trackReviewsTeaserView() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_reviews',
    useLastProducts: true,
  });
}

export function trackAllReviewsClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_reviews',
    label: 'all_reviews',
    useLastProducts: true,
  });
}

export const trackReviewsClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_reviews',
    label: `revews`,
    useLastProducts: true,
  });
};

export const trackHeaderReviewsClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_reviews',
    label: `all_reviews_head`,
    useLastProducts: true,
  });
};
